import { Injectable } from '@angular/core';
import { asyncScheduler, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private _loading = new BehaviorSubject<boolean>(false);
  public readonly loading$ = this._loading.asObservable();

  constructor() {}

  show() {
    asyncScheduler.schedule(() => this._loading.next(true));
  }

  hide() {
    asyncScheduler.schedule(() => this._loading.next(false));
  }
}
